import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import Divider from 'material-ui/Divider';
import { ListItem } from 'material-ui/List';
import { Link } from 'react-router';
import { SelectableList } from 'components';
import * as styles from './LeftNavSidebar.scss';
import classnames from 'classnames';
var LeftNavSidebar = (_dec = connect(function (state) {
  return {
    user: state.auth.user,
    theme: state.theme
  };
}, {}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(LeftNavSidebar, _Component);

  var _super = _createSuper(LeftNavSidebar);

  function LeftNavSidebar(props) {
    var _this;

    _classCallCheck(this, LeftNavSidebar);

    _this = _super.call(this, props);
    _this.state = {
      selected: 1
    };
    return _this;
  }

  _createClass(LeftNavSidebar, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var listItemStyle = {
        borderBottom: '1px solid rgb(224,224,224)',
        paddingBottom: 8,
        paddingTop: 6,
        paddingLeft: 8
      };
      var listValue = this.props.items.findIndex(function (item) {
        return window.location.href.includes(item.link);
      });
      return /*#__PURE__*/React.createElement("div", {
        className: classnames(styles.sidebar, this.props.className)
      }, /*#__PURE__*/React.createElement(SelectableList, {
        defaultValue: listValue + 1,
        onChange: function onChange(index) {
          _this2.setState({
            selected: index
          });
        },
        style: {
          paddingTop: 0
        }
      }, this.props.items.map(function (item, index) {
        return /*#__PURE__*/React.createElement(ListItem, {
          key: index,
          style: listItemStyle,
          value: index + 1,
          primaryText: item.linkText,
          onClick: function onClick() {
            browserHistory.push({
              pathname: item.link
            });
          }
        });
      })));
    }
  }]);

  return LeftNavSidebar;
}(Component)) || _class);
export default LeftNavSidebar;